import { Component } from '@angular/core';

@Component({
    selector: 'altres',
    template: require('./altres.component.html'),
})

export class AltresComponent {    

    constructor() {
    
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/altres/altres.component.ts
 **/